<template>
  <div class="menu-list">
    <!-- <div class="menu-list-item" v-for="(item,index) in menuList" :key="index">
      <p :class="nowRouter === item.url ? 'actived' : ''" @click="goNext(item.url)">{{item.name}}</p>
    </div> -->
    <div
      class="swiper-container customer-swiper"
      v-swiper:mySwiper="swiperOption"
    >
      <div class="swiper-wrapper">
        <div
          class="swiper-slide"
          v-for="(item, index) in menuList"
          :key="index"
        >
          <p
            :class="nowRouter === item.url ? 'actived' : ''"
            @click="goNext(item.url, index + 1)"
          >
            {{ item.name }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from 'swiper'
export default {
  name: 'LeftMenu',
  data () {
    return {
      nowRouter: '', // 当前跳转的路由
      swiperOption: {
        direction: 'vertical',
        centeredSlides: true,
        // loop: true,
        slidesPerView: 5,
        centeredSlides: true,
        observer: true, // 修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, // 修改swiper的父元素时，自动初始化swiper
        // noSwiping : true,
        onSlideChangeEnd: function (swiper) {
          mySwiper.reLoop()
        }
      }
    }
  },
  props: {
    menuList: {
      type: Array
    }
  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        console.log(val)
        this.nowRouter = val.fullPath
      },
      deep: true
    }
  },
  mounted () {
    this.nowRouter = this.$route.path
    this.swiperOption.slidesPerView =
      this.menuList.length < 6 ? this.menuList.length : 5
    // this.mySwiper.reLoop()
    console.log('this.swiperOption', this.swiperOption)
  },
  methods: {
    goNext (path, index) {
      console.log(path, index)
      if (this.nowRouter !== path) {
        this.mySwiper.slideTo(index)
        this.nowRouter = path
        this.$router.push({ path: path })
      }
    }
  }
}
</script>
<style scoped>
.menu-list {
  height: 100%;
  width: 400px;
  overflow: hidden;
  box-sizing: border-box;
  display: flex;
  display: -ms-flexbox;
  display: -webkit-box;
  display: -webkit-flex;
  flex-direction: column;
  -webkit-flex-direction: column;
  padding: 100px 0;
}
.menu-list-item {
  flex: 1 1 auto;
  -ms-flex: 1 1 auto;
  display: flex;
  display: -ms-flexbox;
  display: -webkit-box;
  display: -webkit-flex;
  align-items: center;
  -ms-flex-align: center;
  justify-content: flex-start;
  font-size: 14px;
  color: #999;
  cursor: pointer;
  text-align: left;
  padding-left: 123px;
  box-sizing: border-box;
}
.actived {
  font-size: 24px !important;
  color: #04a6f7 !important;
}
.swiper-container {
  height: 100%;
}
.swiper-slide {
  display: flex;
  display: -ms-flexbox;
  display: -webkit-box;
  display: -webkit-flex;
  align-items: center;
  -ms-flex-align: center;
  justify-content: flex-start;
  font-size: 14px;
  color: #999;
  cursor: pointer;
  text-align: left;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/common/LeftMenu.vue